export function domReady(fn) {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    return fn()
  }

  document.addEventListener("DOMContentLoaded", fn, false)
}

export function init(activeModules) {
  Object.keys(activeModules).forEach((moduleName) => {
    if (!!activeModules[moduleName].init) {
      activeModules[moduleName].init()
    }
  })
}

// export function ajax({ url, data, onSuccess, onError }) {
//   const params = new FormData()

//   if (typeof data == "object") {
//     Object.keys(data).forEach((k) => {
//       params.append(k, data[k])
//     })
//   }

//   const xhr = new XMLHttpRequest()

//   xhr.onreadystatechange = () => {
//     if (xhr.readyState == XMLHttpRequest.DONE) {
//       if (xhr.status == 200) {
//         if (typeof onSuccess == "function") {
//           onSuccess(xhr.response)
//         }
//       } else {
//         if (typeof onError == "function") {
//           onError()
//         }
//       }
//     }
//   }

//   xhr.open("POST", url)
//   xhr.setRequestHeader("Cache-Control", "no-cache")

//   xhr.send(params)
// }

/**
 * A simple Redux-like state management implementation
 *
 * @param {function} reducer The custom reducer.
 * @returns {function} unsubscribe Remove listener.
 */
export function createStore(reducer) {
  let listeners = []
  let currentState = reducer(undefined, {})

  return {
    getState: () => currentState,
    dispatch: (action) => {
      currentState = reducer(currentState, action)

      listeners.forEach((listener) => {
        listener()
      })
    },
    subscribe: (newListener) => {
      listeners.push(newListener)

      const unsubscribe = () => {
        listeners = listeners.filter((l) => l !== newListener)
      }

      return unsubscribe
    },
  }
}

export function getPosition(elem) {
  var box = elem.getBoundingClientRect();

  var body = document.body;
  var docEl = document.documentElement;

  // (2)
  var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  // (3)
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;

  // (4)
  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;

  return {
    top: top,
    left: left
  };
}